import { EMPTY, Observable } from "rxjs";

import {
	ConfirmCogaCustomerProfileRequest,
	ConfirmPegaCustomerProfileRequest,
	Customer,
	CustomerDetailSection,
	CustomerManagementService,
	EmailAvailability,
} from "../customer-management.model";

export class NoopCustomerManagementService implements CustomerManagementService {
	getCustomer(): Observable<Customer> {
		return EMPTY;
	}

	getCustomerDetail(_section: CustomerDetailSection): Observable<Partial<Customer>> {
		return EMPTY;
	}

	updateCustomer(_customer: Partial<Customer>): Observable<Customer> {
		return EMPTY;
	}

	verifyToken(_token: string): Observable<object> {
		return EMPTY;
	}

	checkEmailAvailability(_email: string): Observable<EmailAvailability> {
		return EMPTY;
	}

	unsubscribeFromNewsletter(_token: string): Observable<object> {
		return EMPTY;
	}

	confirmProfile(
		_requestData: ConfirmPegaCustomerProfileRequest | ConfirmCogaCustomerProfileRequest
	): Observable<void> {
		return EMPTY;
	}

	acceptTermsAndConditions(_token: string): Observable<object> {
		return EMPTY;
	}

	acceptLatestTermsAndConditions(_token: string): Observable<void> {
		return EMPTY;
	}

	declineTermsAndConditions(_token: string): Observable<object> {
		return EMPTY;
	}

	acceptDepositTermsAndConditions(): Observable<Partial<Customer>> {
		return EMPTY;
	}

	acceptPrivacyPolicy(_token: string): Observable<void> {
		return EMPTY;
	}

	acceptEntityLegalNotice(_token: string): Observable<void> {
		return EMPTY;
	}

	updateProfileValidation(): Observable<void> {
		return EMPTY;
	}
}
